module.exports = __webpack_public_path__ + "img/Icon_Chevron_Right.1a6b925e.svg";